<template>
  <div class="page-template">
    <div class="page-title">{{title}}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submit">
      </form-template>
      </div>
  </div>
</template>
<script>
  import formTemplate from "@/components/template/formTemplate";
  // import api from "@/config/api";

  export default {
    components: {
      formTemplate,
    },
    data() {
      return {
        title: '',
        dialogVisibility: false,
        // 高级搜索条件
        addColumns: {
          formType: 'add',
          labelWidth: "120px",
          span: 12,
          columns: [
            {
              label: "商户ID",
              type: "input",
              prop: "loginName",
            },
            {
              label: "用户名",
              type: "input",
              prop: "loginName",
            },
            {
              label: "手机号",
              type: "input",
              prop: "name"
            },
            {
              label: "邮箱",
              type: "input",
              prop: "password",
            },
            {
              label: "QQ",
              type: "input",
              prop: "password",
            },
            {
              label: "第三方QQ登陆",
              type: "input",
              prop: "loginName",
            },
            {
              label: "第三方微信登陆",
              type: "text",
              prop: "loginName",
            }
          ],
        }
      };
    },
    mounted() {
      this.title = document.title;
      this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
    },
    methods: {
      submit() {
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/page/system/user/Binding.vue